import SdIconDark from 'assets/SDicon_2white.svg';
// eslint-disable-next-line unicorn/string-content
import SdLogoDark from 'assets/SmartDiagnostics-logo-reverse.svg';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import * as theme from 'styles/theme';
import { KCFColor } from 'styles/themes/KCFColor';

export const NavigationDrawerTransitionMs = 300;

export const NavbarWidth = '6rem';
export const NavbarExpandedWidth = '30rem';

export const NavigationDrawerWrapper = styled.nav<{ $expanded: boolean }>`
    display: grid;
    grid-template-rows: min-content auto min-content;
    min-height: ${NavbarWidth};
    width: ${({ $expanded }) => ($expanded ? NavbarExpandedWidth : NavbarWidth)};
    z-index: 30;
    overflow: hidden;
    color: ${KCFColor.lightGrey1};
    background-color: ${KCFColor.primaryNavigationBackground};
    border-right: 1px solid ${theme.navBorderColor};
    transition: width ${NavigationDrawerTransitionMs}ms ease-in-out;

    @media (prefers-reduced-motion) {
        transition: none;
    }

    @media ${MediaQueries.smallAndDown} {
        display: ${({ $expanded }) => ($expanded ? 'grid' : 'none')};
        width: 30rem;
    }
`;

export const NavigationDrawerHeaderWrapper = styled.div<{ $expanded?: boolean }>`
    display: flex;
    min-height: 7rem;
    width: ${({ $expanded }) => ($expanded ? NavbarExpandedWidth : NavbarWidth)};
    position: relative;
    justify-content: ${({ $expanded }) => ($expanded ? 'right' : 'center')};
    align-items: center;
    color: ${KCFColor.mediumGrey4};
    background-color: ${KCFColor.footerBackground};
    cursor: pointer;
    transition: width ${NavigationDrawerTransitionMs}ms ease-in-out;

    &:hover {
        color: ${KCFColor.lightGrey1};
    }

    @media (prefers-reduced-motion) {
        transition: none;
    }

    @media ${MediaQueries.smallAndDown} {
        width: ${NavbarWidth};
        right: 0rem;
        background-color: transparent;
        color: ${theme.primaryText};

        &:hover {
            color: ${theme.primaryText};
        }
    }
`;

export const NavigationDrawerItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: hidden;
`;

export const NavigationItemAccordion = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NavigationItemIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${NavbarWidth};
    height: ${NavbarWidth};
`;

export const NavigationItemTitle = styled.span<{ $secondary?: boolean }>`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding: ${({ $secondary }) => ($secondary ? '0 2rem' : '0rem')};
    height: ${({ $secondary }) => ($secondary ? '6rem' : '')};
    transition: all ${NavigationDrawerTransitionMs}ms ease-in-out;
    cursor: pointer;

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

export const NavigationItemHeader = styled.div`
    display: grid;
    min-height: 6rem;
    align-items: center;
    grid-template-columns: 6rem 18rem 6rem;

    &:hover {
        ${NavigationItemTitle} {
            transform: translateX(0.4rem) scale(1.01);
            transition: transform ${NavigationDrawerTransitionMs}ms ease-in-out;

            @media (prefers-reduced-motion) {
                transform: none;
                transition: none;
            }
        }
    }
`;

export const SecondaryNavigationItemsWrapper = styled.div<{ $show: boolean }>`
    overflow: hidden;
    max-height: ${({ $show }) => ($show ? '100rem' : '0rem')};
    background-color: ${KCFColor.secondaryNavigationBackground};
    transition: ${({ $show }) =>
        $show ? 'all 0.3s ease-in-out' : 'all 0.3s cubic-bezier(0, 1, 0, 1)'};

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

export const SecondaryNavigationItemHeader = styled(NavLink)`
    display: flex;
    height: 5rem;
    padding: 0rem 2.5rem;
    align-items: center;
    text-decoration: none;
    color: ${KCFColor.lightGrey1};
    transition: all 0.5s ease-in-out;

    &:hover {
        background: ${KCFColor.secondaryNavigationSelected};
        transition: all 0.3s ease-in-out;

        ${NavigationItemTitle} {
            transform: translateX(0.4rem) scale(1.01);
            transition: transform 0.3s ease-in-out;

            @media (prefers-reduced-motion) {
                transform: none;
                transition: none;
            }
        }

        @media (prefers-reduced-motion) {
            transition: none;
        }
    }

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

export const NavigationDrawerFooterWrapper = styled.div<{ $expanded: boolean }>`
    display: flex;
    flex-direction: row;
    width: ${({ $expanded }) => ($expanded ? NavbarExpandedWidth : NavbarWidth)};
    height: ${({ $expanded }) => ($expanded ? 'unset' : NavbarWidth)};

    background-color: ${({ $expanded }) =>
        $expanded ? KCFColor.primaryNavigationBackground : KCFColor.footerBackground};
    transition: all 0.3s ease-in-out;

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

export const NavigationFooterHeader = styled.div`
    display: grid;
    min-height: 6rem;
    align-items: center;
    grid-template-columns: 24rem 6rem;
    color: ${KCFColor.mediumGrey4};
    cursor: pointer;

    &:hover {
        color: ${KCFColor.lightGrey1};
    }
`;

export const NavigationFooterIcon = styled.div<{ $expanded: boolean }>`
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;

    ${({ $expanded }) =>
        $expanded
            ? css`
                  width: 20rem;
                  height: 4rem;
                  margin: 0rem 1.5rem;
                  background-image: url('${SdLogoDark}');
                  transition: width 0.3s ease-in-out;

                  @media (prefers-reduced-motion) {
                      transition: none;
                  }
              `
            : css`
                  height: 6rem;
                  width: ${NavbarWidth};
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &:hover {
                      background-color: ${KCFColor.primaryNavigationHover};
                  }

                  &::after {
                      content: '';
                      display: block;
                      width: 2rem;
                      height: 2rem;
                      // for some reason, this is only partially URL encoded. Idk.
                      background-image: url('${SdIconDark.replaceAll("'", '%27')}');
                      transform: scale(1.5);
                  }
                  transition: all 0.3s ease-in-out;

                  @media (prefers-reduced-motion) {
                      transition: none;
                  }
              `};
`;

export const NavigationChatbotIcon = styled.div<{ $expanded: boolean }>`
    cursor: pointer;
    background-color: ${KCFColor.primaryNavigationBackground};
    color: ${KCFColor.mediumGrey4};
    margin-top: -6rem;

    font-family: Lato;
    font-style: normal;

    ${({ $expanded }) =>
        $expanded
            ? css`
                  width: ${NavbarExpandedWidth};
                  height: 6rem;
                  transition: width 0.3s ease-in-out;
                  border-right: 1px solid ${theme.navBorderColor};

                  align-items: center;
                  display: flex;
                  justify-content: align-start;
                  gap: 2rem;
                  padding-left: 2rem;

                  &:hover {
                      color: ${KCFColor.lightGrey1};
                      background-color: ${KCFColor.primaryNavigationHover};
                      ${NavigationItemTitle} {
                          transform: translateX(0.4rem) scale(1.01);
                          transition: transform ${NavigationDrawerTransitionMs}ms
                              ease-in-out;

                          @media (prefers-reduced-motion) {
                              transform: none;
                              transition: none;
                          }
                      }
                  }

                  @media (prefers-reduced-motion) {
                      transition: none;
                  }
              `
            : css`
                  height: 6rem;
                  width: ${NavbarWidth};
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &:hover {
                      background-color: ${KCFColor.primaryNavigationHover};
                  }

                  transition: all 0.3s ease-in-out;

                  @media (prefers-reduced-motion) {
                      transition: none;
                  }
              `};
`;

export const NavigationFooterItems = styled.div<{ $show: boolean }>`
    overflow: hidden;
    max-height: ${({ $show }) => ($show ? '50rem' : '0rem')};
    transition: ${({ $show }) =>
        $show ? 'all 0.3s ease-in-out' : 'all 0.3s cubic-bezier(0, 1, 0, 1)'};

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

export const NavigationItem = styled(NavLink)<{
    $isDrawerExpanded?: boolean;
    $isExpanded?: boolean;
    $hoverColor?: string;
}>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    min-height: 6rem;
    transition-property: background, width, color;
    transition-timing-function: ease-in-out;
    color: ${({ $isExpanded }) =>
        $isExpanded ? KCFColor.lightGrey1 : KCFColor.mediumGrey4};
    background: ${({ $isExpanded }) =>
        $isExpanded ? KCFColor.primaryNavigationHover : 'none'};
    transition-duration: ${({ $isDrawerExpanded }) =>
        $isDrawerExpanded ? '0.5s' : 'none'};

    &:hover {
        color: ${KCFColor.lightGrey1};
        background: ${({ $isDrawerExpanded, $hoverColor }) =>
            $isDrawerExpanded ? KCFColor.primaryNavigationHover : $hoverColor};
        transition-duration: ${({ $isDrawerExpanded }) =>
            $isDrawerExpanded ? '0.3s' : 'none'};

        @media (prefers-reduced-motion) {
            transition: none;
        }
    }

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;
